import React, { useState } from "react";
import "../Styles/Home.css";
import logoMain from "../Assets/logoNH7.png";
import artistlineup from "../Assets/Home/artistlineup.svg";
import experiences from "../Assets/Home/experiences.svg";
import festivalmap from "../Assets/Home/festivalmap.svg";
import barmenu from "../Assets/Home/barmenu.svg";
import safety from "../Assets/Home/safety.svg";
import bottomLogoUnit from "../Assets/BottomLogoUnit.svg";

const Home = () => {
  return (
    <div>
      <section>
        <div className="content_div">
          <div>
            <a href="/">
              <img
                src={logoMain}
                className="logoMain"
                alt="nh7 Weekender logo"
              ></img>
            </a>
          </div>

          <div className="nav_tabs">
            <div>
              <a href="/artistlineup" className="nav_tabs_main">
                <img
                  src={artistlineup}
                  className="nav_tabs_img"
                  alt="artist line up"
                ></img>
              </a>
            </div>
            <div>
              <a href="/experiences" className="nav_tabs_main">
                <img
                  src={experiences}
                  className="nav_tabs_img"
                  alt="Experiences"
                ></img>
              </a>
            </div>
            <div>
              <a href="/barfoodmenu" className="nav_tabs_main">
                <img
                  src={barmenu}
                  className="nav_tabs_img"
                  alt="Bar & Food menu"
                ></img>
              </a>
            </div>
            <div>
              <a href="/safety" className="nav_tabs_main">
                <img src={safety} className="nav_tabs_img" alt="Safety"></img>
              </a>
            </div>
            <div>
              <a href="/festivalmap" className="nav_tabs_main">
                <img
                  src={festivalmap}
                  className="nav_tabs_img"
                  alt="festival map"
                ></img>
              </a>
            </div>
          </div>
        </div>
        <div className="logo_unit">
          <img
            src={bottomLogoUnit}
            className="bottom_unit"
            alt="logo - bacardi, paytm, nodwin"
          ></img>
        </div>
      </section>
    </div>
  );
};

export default Home;
